// Shared hover tooltip used by AssetMarker / LocationMarkers /
// AccessPointMarkers / RescueChamberMarkers. Renders a small DOM badge
// anchored at a 3D world position via drei's <Html>.
//
// Visibility is controlled by the parent (each marker manages its own
// hovered state with a 200 ms enter-delay). On touch devices the parent
// simply never sets `visible` to true, so the tooltip never renders.

import React from 'react'
import {Html} from '@react-three/drei'

interface MarkerHoverLabelProps {
  visible: boolean
  /** World position to anchor at. Usually the marker's own position. */
  position: [number, number, number]
  /** First line — entity name (or whatever the marker chooses to surface). */
  primary: string
  /** Optional second line — e.g. 'Active', 'Idle · 12/20', 'Fault'. */
  secondary?: string
}

export const MarkerHoverLabel: React.FC<MarkerHoverLabelProps> = ({
  visible, position, primary, secondary,
}) => {
  if (!visible) return null
  return (
    <Html
      position={position}
      style={{pointerEvents: 'none'}}
      zIndexRange={[90, 0]}
    >
      <div
        className={
          'pointer-events-none translate-x-[12px] -translate-y-[100%] ' +
          'rounded-md border border-surfaceBorder bg-surfaceCard ' +
          'px-md py-xs text-xs shadow-lg ring-1 ring-black/40 whitespace-nowrap'
        }
      >
        <div className="font-semibold text-textPrimary">{primary}</div>
        {secondary && (
          <div className="mt-[2px] text-[10px] text-textMuted">{secondary}</div>
        )}
      </div>
    </Html>
  )
}
